const easeInOutQuad = function(currentTime, start, change, duration) {
  currentTime /= duration / 2;
  if (currentTime < 1) return change / 2 * currentTime * currentTime + start;
  currentTime--;
  return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
};

export const scrollToWithAnimation = (element, to, duration) => {
  let start = element.scrollTop;
  let change = to - start;
  let currentTime = 0;
  let increment = 20;

  const animateScroll = function() {
    currentTime += increment;
    var val = easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
};

export const scrollToWithAnimationP = (element, to, duration) => {
  return new Promise((resolve, reject) => {
    if (!element) {
      reject('Provide a valid HTML Element');
    }

    let start = element.scrollTop;
    let change = to - start;
    let currentTime = 0;
    let increment = 20;

    const animateScroll = function() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      } else {
        resolve();
      }
    };

    animateScroll();
  })
};
